import {DAppProfileOverview} from '../../modules/dApp/DAppProfileOverview';

export default DAppProfileOverview
